
import {PrescriptionState} from '@store/types/prescription.types'
import {Prescription} from '@interfaces/prescription'

export const UPDATE_RX_CONFIGURATOR_SCRIPTS_LOADED = 'UPDATE_RX_CONFIGURATOR_SCRIPTS_LOADED'
export const UPDATE_RX_CONFIGURATOR_SET_IS_OPEN = 'UPDATE_RX_CONFIGURATOR_SET_IS_OPEN'
export const UPDATE_PRESCRIPTION_DATA_LOADING = 'UPDATE_PRESCRIPTION_DATA_LOADING'
export const UPDATE_PRESCRIPTION_DATA_ERROR = 'UPDATE_PRESCRIPTION_DATA_ERROR'
export const UPDATE_PRESCRIPTION_DATA_UPDATED = 'UPDATE_PRESCRIPTION_DATA_UPDATED'
export const UPDATE_PRESCRIPTION_CART_ITEM_DATA = 'UPDATE_PRESCRIPTION_CART_ITEM_DATA'
export const UPDATE_PRESCRIPTION_DATA_RESET = 'UPDATE_PRESCRIPTION_DATA_RESET'
export const UPDATE_RX_WARRANTY_PRICE = 'UPDATE_RX_WARRANTY_PRICE'

export const mutations = {
  [UPDATE_RX_CONFIGURATOR_SCRIPTS_LOADED](state: PrescriptionState) {
    state.configurator.scriptsAreLoaded = true
  },
  [UPDATE_RX_CONFIGURATOR_SET_IS_OPEN](state: PrescriptionState, isOpen: boolean) {
    state.configurator.isOpen = isOpen
  },
  [UPDATE_PRESCRIPTION_DATA_LOADING](state: PrescriptionState, loading: boolean) {
    state.prescription.loading = loading
  },
  [UPDATE_PRESCRIPTION_DATA_ERROR](state: PrescriptionState, error: string | null) {
    state.prescription.error = error
  },
  [UPDATE_PRESCRIPTION_DATA_UPDATED](state: PrescriptionState, payload:Prescription) {
    state.prescription = {
      ...state.prescription,
      data: payload,
    }
  },
  [UPDATE_PRESCRIPTION_CART_ITEM_DATA](state: PrescriptionState, payload: {
    productUPC?: string | null;
    catEntryId?: string | null;
    orderItemId?: string | null;
    lensUPC?: string | null;
  }) {
    state.order = payload
  },
  [UPDATE_PRESCRIPTION_DATA_RESET](state: PrescriptionState) {
    state.prescription = {
      ...state.prescription,
      data: {
        ...state.prescription.data ,
        fileName: null,
        fileData: null,
        prescriptionId: null,
      },
    }
  },
  [UPDATE_RX_WARRANTY_PRICE](state: PrescriptionState, payload: string) {
    state.configurator.warrantyPrice = payload
  },
}
